module.exports = __webpack_public_path__ + "static/media/port-adelaide-logo.13e05937.svg";